/** Cache windows by data class. Realtime events and mutations invalidate sooner. */
export const queryPolicies = {
  default: { staleTime: 60_000, gcTime: 10 * 60_000 },
  metadata: { staleTime: 20 * 60_000, gcTime: 30 * 60_000 },
  // Dashboard aggregates are operational data and may change after role/cache
  // repairs; do not pin an empty result in the browser for twenty minutes.
  dashboardAggregate: { staleTime: 60_000, gcTime: 10 * 60_000 },
  recordDetail: { staleTime: 30_000, gcTime: 5 * 60_000 },
  pagedData: { staleTime: 45_000, gcTime: 5 * 60_000 },
  permissions: { staleTime: 5 * 60_000, gcTime: 10 * 60_000 },
  configuration: { staleTime: 10 * 60_000, gcTime: 20 * 60_000 },
} as const;
